<div class="cbar">
  <div class="ms-CommandBar">
    <div class="ms-CommandBar-mainArea">
      <div class="ms-CommandButton">
        <button
          (click)="abrirModalCrear()"
          class="ms-CommandButton-button"
          type="button"
        >
          <span class="ms-CommandButton-icon ms-fontColor-themePrimary"
            ><i class="ms-Icon ms-Icon--CalculatorAddition"></i
          ></span>
          <span class="ms-CommandButton-label">Nuevo</span>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="pageContent">
  <div class="pageTitle">
    <h2>Roles</h2>
  </div>
  <app-data-table tableId="datatableRoles" [serverSide]="true" [serverData]="getDataTableRol" [columns]="columnas" (loadedGrid)="gridLoaded($event)" (custom)="customClick($event)" [buttonsOptions]="dtOptButtons"></app-data-table>
</div>

<!-- Nuevo -->
<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader create-rol" appPreventOutsideClick>
    <div id="dialogCreateEdit" class="ms-Dialog-title">Crear Rol</div>
    <form [formGroup]="roleForm" (ngSubmit)="crearEditarRol()" name="roleForm">
      <div class="ms-Dialog-content">
        <div>
          <app-text-box [frm]="roleForm" formControlName="NombreRol" type="text" [required]="true" label="Rol" [min]="8" [max]="50"></app-text-box>
        </div>
        <div>
          <app-text-area [frm]="roleForm" formControlName="Descripcion" [required]="true" label="Descripción" rows="3" [min]="15" [max]="50" ></app-text-area>
        </div>
        <app-check-box [frm]="roleForm" formControlName="Activo" label="Activo"></app-check-box>
        <app-check-box [frm]="roleForm" formControlName="TodosProcesos" label="Todos Procesos"></app-check-box>
      </div>
      <app-form-buttons 
        [botonProcesando]="botonProcesando"
        buttonCancelId="btnCancel"
        labelCancel="Cancelar"
        buttonSaveId="btnCreateEdit"
        labelSave="Crear"
        [labelLoading]="textoBotonProcesando" 
        [frm]="roleForm"
        (cancel)="clearFormRol()"
        [validate]="true">
      </app-form-buttons>
    </form>
  </div>

</div>

<app-modal-notify #crearModal></app-modal-notify>
